import { useFormik } from "formik";
import _ from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { TitleHeader } from "../../Common/Components/TitleHeader";
import useCartTotal from "../../Common/Hooks/useCartTotal";
import {
  calculateBundleOffer,
  fetchLaundryItem,
  fetchServices,
  getBundleMessage,
} from "../../Services/CartService";
import { CartTotal } from "../../Common/Components/CartTotal";
import LaundryItemCard from "../../Common/Components/LaundryItemCard";

export const Cart = () => {
  const [services, setServices] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [initLoading, setInitLoading] = React.useState(true);
  const [itemsLoading, setItemsLoading] = React.useState(false);
  const [laundryItems, setLaundryItem] = React.useState([]);
  const [amount, total] = useCartTotal();
  const [reload, setReload] = React.useState("");
  const [campaign, setCampaign] = React.useState(null);
  const [cShow, setCShow] = React.useState(false);
  const [payload, setPayload] = React.useState({
    serviceId: null,
    categoryId: null,
    limit: 100,
    offset: 1,
  });
  const lastService = useSelector((x) => x.Service);
  const lastCategory = useSelector((x) => x.Category);
  const cart = useSelector((x) => x.Cart);
  const config = useSelector((x) => x.Config);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const bookingType = useSelector((x) => x.BookingType);
  const cCart = () => {
    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setPickupDate", payload: null });
    dispatch({ type: "setDeliveryDate", payload: null });
    dispatch({ type: "setAddresses", payload: null });
    formik.setValues({ cart: { items: [] } });
    setReload(Date.now().toString());
  };
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      cart: {
        items: [],
      },
    },
  });

  React.useEffect(() => {
    if (cart.length !== 0) {
      fetchServices(20, 1, orderTypeId).then(
        (res) => {
          setServices(res);
          let selectedService;
          if (lastService && lastService != "null") {
            selectedService = res.find((x) => x.id === parseInt(lastService));
            setPayload((state) => ({
              ...state,
              serviceId: selectedService?.id,
            }));
          } else {
            selectedService = res[0];
            setPayload((state) => ({
              ...state,
              serviceId: selectedService?.id,
            }));
          }
          const cats = selectedService?.categories || [];
          setCategories(cats);
          let selectedCategory;
          if (lastCategory && lastCategory != "null") {
            selectedCategory = cats.find(
              (x) => x.id === parseInt(lastCategory)
            );
            setPayload((state) => ({
              ...state,
              categoryId: selectedCategory?.id,
            }));
          } else {
            selectedCategory = cats[0];
            setPayload((state) => ({
              ...state,
              categoryId: selectedCategory?.id,
            }));
          }
          setInitLoading(false);
        },
        (er) => {
          console.warn("Something went wrong on services...");
        }
      );
    }
  }, []);

  React.useEffect(() => {
    if (!initLoading && !itemsLoading) {
      setItemsLoading(true);
      fetchLaundryItem(payload).then(
        (res) => {
          setItemsLoading(false);
          setLaundryItem(res.data);
          setCampaign(res.campain[0]);
        },
        (er) => {
          setItemsLoading(false);
          console.warn(er, "error on laundry item.");
        }
      );
    }
  }, [initLoading, payload, reload]);
  React.useEffect(() => {
    formik.setValues((y) => ({
      ...y,
      cart: {
        ...y.cart,
        items: laundryItems
          .map((x) => {
            const fCart = cart.find(
              (f) =>
                f.laundry_item_id === x.id && f.serviceId === x.services[0]?.id
            );
            const newPrice =
              bookingType === 2
                ? typeof x.services[0].pivot.e_price == "string"
                  ? parseFloat(x.services[0].pivot.e_price)
                  : x.services[0].pivot.e_price
                : typeof x.services[0].pivot.price == "string"
                ? parseFloat(x.services[0].pivot.price)
                : x.services[0].pivot.price;
            if (fCart) {
              const fadb9 = {
                ...fCart,
                addons: x.addons.map((z) => {
                  const fAd = fCart.addons.find((ffAd) => ffAd.id === z.id);
                  if (fAd) return fAd;
                  else
                    return {
                      id: z.id,
                      name: z.name,
                      price: z.price,
                      qty: 0,
                    };
                }),
                price: newPrice,
                actualPrice: newPrice,
              };
              if (campaign) {
                fadb9.price =
                  fadb9.price - fadb9.price * (campaign.discount / 100);
              }
              return fadb9;
            }
          })
          .filter((x) => x),
      },
    }));
  }, [laundryItems, bookingType, campaign]);

  React.useEffect(() => {
    if (!initLoading) {
      const items = [...formik.values.cart.items];
      const currentCart = [...cart];
      const newItems = [...items];

      let updatedCart = currentCart.map((item) => {
        const newItem = newItems.find(
          (newItem) =>
            newItem.laundry_item_id === item.laundry_item_id &&
            newItem.serviceId === item.serviceId
        );
        return newItem || item;
      });

      newItems
        .filter((x) => x.quantity !== 0)
        .forEach((newItem) => {
          if (
            !updatedCart.find(
              (item) =>
                item.laundry_item_id === newItem.laundry_item_id &&
                item.serviceId === newItem.serviceId
            )
          ) {
            updatedCart.push(newItem);
          }
        });

      for (let i = 0; i < updatedCart.length; i++) {
        const x = updatedCart[i];
        const y = { ...x, addons: [] };

        if (x.quantity !== 0) {
          for (let j = 0; j < x.addons.length; j++) {
            const z = x.addons[j];
            if (z.qty !== 0) {
              y.addons.push(z);
            }
          }
          // newItems.push(y);
        }
        updatedCart[i] = y;
      }
      const itemsToFilter = updatedCart.filter((x) => x.quantity === 0);
      updatedCart = updatedCart.filter((x) => x.quantity !== 0);
      if (itemsToFilter.length > 0) {
        formik.setValues((v) => ({
          cart: {
            items: v.cart.items.filter((x) => x.quantity !== 0),
          },
        }));
      }

      dispatch({ type: "setCart", payload: updatedCart });
    }
  }, [formik.values, initLoading, dispatch]);

  React.useEffect(() => {
    const uniqueServiceIds = new Set(cart.map((item) => item.serviceId));
    const ns = services.filter((service) => uniqueServiceIds.has(service.id));
    if (!_.isEqual(services, ns)) {
      setServices(ns);
    }
  }, [cart, services]);

  React.useEffect(() => {
    if (services.length > 0 && lastService) {
      const i = services.findIndex((x) => x.id == lastService);
      if (!~i) {
        dispatch({ type: "setService", payload: services[0]?.id });
        setPayload((state) => ({ ...state, serviceId: services[0]?.id }));
      }
    }
  }, [services, lastService]);

  const selectService = (serviceId) => {
    setPayload((state) => ({ ...state, serviceId }));
    dispatch({ type: "setService", payload: serviceId });
  };
  const selectCategory = (categoryId) => {
    setPayload((state) => ({ ...state, categoryId }));
    dispatch({ type: "setCategory", payload: categoryId });
  };
  const toggleAddons = (index) => {
    setLaundryItem((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, showAddons: !item.showAddons } : item
      )
    );
  };
  const changeItemQuantity = (index, value) => {
    formik.setValues((v) => ({
      cart: {
        items: v.cart.items.map((v, i) => {
          if (i === index) {
            const item = { ...v, quantity: value };
            if (item.bundle_buy > 0)
              item.free_items = calculateBundleOffer({
                totalQuantity: value,
                bundleBuy: item.bundle_buy,
                bundleFree: item.bundle_free,
                itemPrice: item.price,
              }).freeItems;
            return item;
          }
          return v;
        }),
      },
    }));
  };
  const changeAddonQuantity = (itemIndex, addonIndex, qty) => {
    formik.setValues((v) => ({
      cart: {
        items: v.cart.items.map((v, i) =>
          i === itemIndex
            ? {
                ...v,
                addons: v.addons.map((ad, adI) =>
                  addonIndex === adI ? { ...ad, qty } : ad
                ),
              }
            : v
        ),
      },
    }));
  };
  const getLaundryItem = (id) => {
    return laundryItems.find((x) => x.id == id);
  };
  const getServiceName = (id) => {
    return services.find((x) => x.id == id)?.name;
  };
  const getOffer = (id) => {
    return getLaundryItem(id)?.bundle_offer;
  };
  const changeItemNote = (itemIndex, item_note) => {
  formik.setValues((v) => ({
    cart: {
      items: v.cart.items.map((item, i) =>
        i === itemIndex ? { ...item, item_note } : item
      ),
    },
  }));
  };

  return (
    <>
      <TitleHeader title="My Cart" subtitle="Below are your cart details" />
      <div className="container py-3" style={{ minHeight: "35vh" }}>
        {cart.length === 0 ? (
          <div className="col-12 text-center">
            <h4 className="text-muted text-uppercase">Your cart is empty!</h4>
          </div>
        ) : initLoading ? (
          <>
            <div
              className="row justify-content-center align-items-center"
              style={{ height: "50vh" }}
            >
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className="row justify-content-start justify-content-md-center column-gap-3 row-gap-3 px-4 select-category-chip-container"
              style={{
                padding: "20px 0px 20px",
                flexWrap: "nowrap",
                width: "100%",
                overflowX: "auto",
              }}
            >
              {services.map((e) => (
                <div
                  className={`select-category-chip ${
                    e.id === payload.serviceId ? "selected" : ""
                  }`}
                  onClick={() => selectService(e.id)}
                >
                  {e.name}
                </div>
              ))}
            </div>
            <div
              className="row justify-content-start justify-content-md-center column-gap-3 row-gap-3 px-4 select-category-chip-container"
              style={{
                marginBottom: "30px",
                flexWrap: "nowrap",
                width: "100%",
                overflowX: "auto",
              }}
            >
              {categories.map((e) => (
                <div
                  className={`select-category-chip ${
                    e.id === payload.categoryId ? "selected" : ""
                  }`}
                  onClick={() => selectCategory(e.id)}
                >
                  {e.name}
                </div>
              ))}
            </div>
            <div className="row px-4 justify-content-center">
              <div className="col-lg-10 col-12 my-3">
                <div
                  className={`row ${
                    formik.values.cart.items?.length === 0 || itemsLoading
                      ? "justify-content-center"
                      : "justify-content-between"
                  }  align-items-center`}
                  style={{ rowGap: "17px" }}
                >
                  {itemsLoading ? (
                    <div className="col-12 text-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : formik.values.cart.items?.length === 0 ? (
                    <div className="col-auto d-flex align-items-center flex-column py-3">
                      <img
                        src={process.env.PUBLIC_URL + "/assets/images/noitemicon.png"}
                        alt=""
                        style={{ width: "70px" }}
                      />
                      <h6 className="mt-3 mb-0">
                        There are no laundry items in this category...
                      </h6>
                    </div>
                  ) : (
                    formik.values.cart.items?.map((e, itemIndex) => (
                      <LaundryItemCard
                        key={itemIndex}
                        laundryItem={getLaundryItem(e.laundry_item_id)}
                        description={getLaundryItem(e.laundry_item_id)?.description}
                        campaign={campaign}
                        item={e}
                        itemIndex={itemIndex}
                        changeAddonQuantity={changeAddonQuantity}
                        changeItemQuantity={changeItemQuantity}
                        toggleAddons={toggleAddons}
                        offer={getOffer(e.laundry_item_id)}
                        bundleMessage={getBundleMessage(e)}
                        onNoteChange={(item_note) => changeItemNote(itemIndex, item_note)}
                      />
                    ))
                  )}
                </div>
              </div>
            </div>
            <CartTotal />
          </>
        )}
      </div>
      <div className="container-fluid bg-white">
        <div
          className="row justify-content-center"
          style={{ padding: "20px 0px" }}
        >
          <div
            className="d-flex col-lg-6 col-md-7 col-12 justify-content-center flex-column flex-md-row some-random-buttons"
            style={{ columnGap: "20px", rowGap: "10px" }}
          >
            {total > 0 ? (
              <div
                className="service-btn danger"
                onClick={() => setCShow(true)}
              >
                Clear Cart
              </div>
            ) : null}
            <Link className="service-btn cart" to="/app/new-order">
              Continue
            </Link>
            {cart.length !== 0 ? (
              config.laundry_customer_minimum_purchase <= amount ? (
                <>
                  <Link to="/app/new-order" className="service-btn next">
                    Checkout
                  </Link>
                </>
              ) : (
                <>
                  <div
                    className="service-btn next"
                    onClick={() =>
                      toast.error(
                        `Minimum order value should be above Rs.${config.laundry_customer_minimum_purchase}`
                      )
                    }
                  >
                    Checkout
                  </div>
                </>
              )
            ) : null}
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={cShow}
        text="Are you sure you want to clear your cart? "
        onNo={() => {
          setCShow(false);
        }}
        onYes={() => {
          setCShow(false);
          cCart();
        }}
      />
    </>
  );
};
